export default __webpack_public_path__ + "locales/ko-KR/PeopleTranslations.json?hash=3c979533a5736c622f043849f42eec91";